import styled from '@emotion/styled';
import { rgba, darken } from 'polished';

import leadAdTermsImg from 'assets/lead-ad-instructions.png';

import Button from '~/theseus/components/Button';

import { blue } from '~/theseus/styles/core';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h2 {
    font-size: 21px;
    font-weight: 500;
    margin-bottom: 40px;
  }

  p {
    font-size: 14px;
    font-weight: 500;
  }
`;

export const FacebookLink = styled(Button)`
  display: inline-block;
  margin: 40px 0;
  padding: 16px 40px;
  text-decoration: none;
`;

export const PageName = styled.span`
  display: inline-block;
  margin: 1px;
  padding: 2px 6px;
  background: #fff;
  border-radius: 2px;
  border: 1px solid ${rgba('#000', 0.1)};
  color: ${blue};
  white-space: nowrap;
`;

export const Content = styled.div`
  max-width: 90%;
  margin: auto;
  padding: 20px;
  border-radius: 4px;
  border: 1px solid ${rgba('#000', 0.1)};
  background: ${darken(0.01, '#fff')};
`;

export const InstructionsContent = styled(Content)`
  ol {
    text-align: left;
    list-style: decimal;
    padding-left: 20px;
  }

  li {
    color: ${rgba('#000', 0.8)};
    font-size: 14px;
    font-weight: 500;

    &:not(:last-child) {
      margin-bottom: 10px;
    }

    &:first-child:after {
      content: '';
      margin: 10px 0;
      display: block;
      height: 80px;
      background: url(${leadAdTermsImg});
      background-position: -30px -20px;
    }
  }
`;

export const AwaitingApprovalContent = styled(Content)`
  max-width: 100%;
  margin: 20px;
`;
